// Helpers para parsear y construir URLs de CTA tipo WhatsApp.
// El backend acepta cualquier URL valida (ver ALLOWED_CTA_SCHEMES en format.ts);
// aca encapsulamos solo la conveniencia de UI para wa.me.

const WA_RE = /^(?:https?:\/\/)?wa\.me\/(\d+)(?:\?(.*))?$/i

export type ParsedWhatsApp = {
  phone: string
  message: string
}

export function parseWhatsApp(url: string): ParsedWhatsApp | null {
  const trimmed = url.trim()
  if (!trimmed) return null
  const m = trimmed.match(WA_RE)
  if (!m) return null
  const phone = m[1] ?? ''
  let message = ''
  if (m[2]) {
    try {
      const params = new URLSearchParams(m[2])
      message = params.get('text') ?? ''
    } catch {
      message = ''
    }
  }
  return { phone, message }
}

export function buildWhatsAppUrl(phoneInput: string, message: string): string {
  // wa.me espera digitos puros con codigo de pais (sin +, espacios, guiones).
  const digits = phoneInput.replace(/\D/g, '')
  if (!digits) return ''
  const base = `https://wa.me/${digits}`
  const text = message.trim()
  if (!text) return base
  return `${base}?text=${encodeURIComponent(text)}`
}

export function isWhatsAppUrl(url: string): boolean {
  return parseWhatsApp(url) !== null
}
